import styled from 'styled-components'
import {
  widthResize,
  widthFull,
  heightHeader,
  brandDark,
  muted,
  bgApp,
  surface,
  borderSoft,
} from '../Resources/Theme'
import Helpers from '../../Helpers/Helpers'

const PageWrapper = styled.div`
  margin-left: ${props => props.resize ? widthResize : widthFull};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  transition: .35s ease;
  background: ${bgApp};
  min-height: 100vh;

  @media (max-width: 992px) {
    width: 100%;
    margin-left: 0;
  }
`
PageWrapper.BgTop = styled.div`
  top: 0;
  padding: 0 24px;
  padding-top: calc(${heightHeader} + 12px);
  width: 100%;
  min-height: 120px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background: linear-gradient(180deg, ${surface} 0%, ${bgApp} 100%);
  border-bottom: 1px solid ${borderSoft};
  background-image: linear-gradient(180deg, rgba(255,255,255,0.92) 0%, ${bgApp} 100%),
    url("${Helpers.config.resourcesUrl({ url: '/images/dashboard/background-banner-dashboard.png?' + Date.now() })}");
  background-size: cover, contain;
  background-repeat: no-repeat, no-repeat;
  background-position: center, center top;

  @media(max-width: 480px) {
   min-height: 96px;
   padding-top: calc(${heightHeader} + 4px);
   padding-left: 16px;
   padding-right: 16px;
  }
`
PageWrapper.Title = styled.h4`
  margin-bottom: 12px;
  align-self: flex-end;
  font-weight: 700;
  color: ${brandDark};
  letter-spacing: -0.02em;
  font-size: 1.35rem;

  @media (max-width: 992px) {
    font-size: 1.1rem;
  }
`
PageWrapper.Body = styled.div`
  position: relative;
  top: 0;
  padding: 20px 24px 28px;
  min-height: calc(100vh - 160px);

  @media (max-width: 480px) {
    padding: 16px;
  }
`

/* Start BreadCrumb */
PageWrapper.BreadCrumb = styled.div`
  font-weight: 400;
  display: flex;
  align-self: flex-end;
  margin-bottom: 14px;
  color: ${muted};
  font-size: 0.8rem;
  
  @media (max-width: 992px) {
    display: none;
  }
`
PageWrapper.BreadCrumb.Title = styled.span`
  margin-right: .7rem;
  display: flex;
  font-weight: ${props => props.active ? '600' : '400'};
  color: ${props => props.active ? brandDark : muted};
  align-self: center;
`
PageWrapper.BreadCrumb.Icon = styled.div`
  align-self: center;
  transform: rotate(135deg);
  content: '';
  width: 5px;
  height: 5px;
  border-width: 1.5px 0 0 1.5px;
  border-style: solid;
  border-color: ${muted};
  margin-right: .7rem;
  opacity: 0.6;
`
/* End BreadCrumb */

export default PageWrapper
